import { useGetQuery } from 'Hooks/useGetQuery';
import { CustomerType, QueryKeys, ResponseType } from 'Types/common';

export const useGetUserCustomerData = (): CustomerType | undefined => {
  const data = useGetQuery<ResponseType<CustomerType>>([QueryKeys.FETCH_GET_CUSTOMER]);
  const info = data?.data;
  return info?.item;
};
